import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Controller, useForm } from "react-hook-form";

import moment from "moment";
import MomentUtils from "@date-io/moment";

import {
	DatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Styles from "./FormRequestsFilter.module.css";

import "moment/locale/pt";
moment.locale("pt");

const FormRequestsFilter = (props) => {
	const { handleSubmit, setValue, control } = useForm();	

	const CoursesSearchData = useSelector((state) => state.MyCoursesData.searchData);

	const resetForm = () => {
		console.log("resetForm");
		setValue("Name", "");
		setValue("trainingType", "");
		setValue("requestDate", null);
		setValue("statusId", "");
	};
	
	const onSubmit = (data) => {
		console.log("FormRequestsFilter", data);

		const refactorData = {...data, requestDate: moment(data.requestDate).toISOString()}		
		console.log("refactorData", refactorData)
		
		props.filterData(refactorData);
	};

	useEffect(() => {
		// console.log("clear date")
		setValue("requestDate", null);
	}, [setValue]);

	useEffect(() => {
		console.log("CoursesSearchData", CoursesSearchData);
	}, [CoursesSearchData]);


	return (
		<form
			className={Styles["formRequestsFilter"]}
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Nome
				</InputLabel>
				<Controller
					name="Name"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-name"
							variant="outlined"
							autoComplete="off"
							type="text"
						/>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Tipo
				</InputLabel>
				<Controller
					name="trainingType"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-modality"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesSearchData.trainingTypes.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.display}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Data do Pedido
				</InputLabel>
				<Controller
					name="requestDate"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<MuiPickersUtilsProvider utils={MomentUtils}>
							<DatePicker
								value={value}
								onChange={onChange}
								disableToolbar
								className={Styles["text-field"]}
								variant="inline"
								inputVariant="outlined"
								format="DD-MM-YYYY"
							/>
						</MuiPickersUtilsProvider>
					)}
				/>
			</div>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Estado
				</InputLabel>
				<Controller
					name="statusId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-modality"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesSearchData.enrollmentRequestStatuses.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-3"}></div>
			<div className={"col-xs-3"}></div>
			<div className={"col-xs-3"}>
				<Button
					variant="contained"
					className={Styles["btn-filter"]}
					color="primary"
					disableElevation
					onClick={resetForm}
				>
					Limpar Dados
				</Button>
			</div>
			<div className={"col-xs-3"}>
				<Button
					type="submit"
					variant="contained"
					color="primary"
					className={Styles["btn-search"]}
					disableElevation
				>
					Pesquisar
				</Button>
			</div>
		</form>
	);
};

export default FormRequestsFilter;
